export enum EnvironmentEnum {
  LOCAL = "local",
  TESTING = "testing",
  PRODUCTION = "production",
}
